"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vouchers_1 = require("../../economy/vouchers");
const payment_plans_1 = require("../../economy/payment-plans");
const map = {
    is: {
        currently: 'nl',
    },
    mentionContent: {
        reminderFeeRow: 'Herinneringskosten volgens de Interest Act sectie 9b, subsectie 2',
        debtCollectionFeeRow: 'Incassokosten volgens de Interest Act sectie 9b, subsectie 1',
        debtCollectionCostRow: 'Incassokosten volgens de Interest Act sectie 9a, subsectie 1',
        compensationFeeRow: 'Compensatiekosten volgens de Interest Act sectie 9a, subsectie 3',
        fixedInterestRow: 'Eerder opgebouwde rente',
        processInterestRow: 'Opgelopen rente vanaf de vervaldatum',
        yearlyInterestRow: 'Opgelopen rente',
        otherCosts: 'Overige kosten',
        sum: 'Totaal openstaand',
        paid: 'Al betaald',
        invoice: 'Factuur',
        date: 'Datum',
        dueDate: 'Vervaldatum',
        amount: 'Bedrag',
        email: 'E-mail',
        phone: 'Telefoon',
        signature: 'Handtekening',
        journalNumber: 'Dossiernummer:',
        genericEmailSubjectPre: 'Betreffende uw schuld aan',
        genericEmailSubjectForAlternativeContactPre: 'Dossier bij',
        satisfactionsOrClick: 'of klik',
        satisfactionsHere: 'hier',
        principalReferenceIdsAnd: ' en ',
    },
    debtorWebPaymentPlans: {
        backToCase: 'Terug naar zaak',
        paymentPlanOn: 'Betalingsplan op zaak',
        selectPlan: 'Selecteer betalingsplan',
        sign: 'Onderteken overeenkomst',
        gatherInfo: 'Voer informatie in',
        paymentMethod: 'Selecteer betaalmethode',
        approval: 'Goedkeuring',
        info: 'Informatie',
        paymentPlan: 'Betalingsplan',
        firstPayment: 'Eerste betaling',
        entry: 'invoer',
        lastPayment: 'Laatste betaling',
        signedDoc: 'Ondertekend document',
        needHelp: 'Hulp nodig?',
        orPay: 'Of betaal de hele schuld',
        pay: 'Betaal de hele schuld',
        months: 'Maanden',
        month: 'maand',
        total: 'Totale betaling',
        select: 'Selecteer',
        noOptions: 'Helaas is het niet mogelijk om een betalingsplan op te zetten.',
        signTextOne: 'Om je aan te melden voor een betalingsplan met',
        signTextTwoAlternativeContact: 'moet de schuldenaar de volgende overeenkomst ondertekenen.',
        signTextTwoDebtor: 'moet je de volgende overeenkomst ondertekenen.',
        signTextThree: 'Voordat je de overeenkomst kunt ondertekenen, moet je je gegevens invoeren.',
        agreement: 'Onderteken overeenkomst',
        approvalText: 'Gefeliciteerd. Je hebt een betalingsplan afgesloten.',
        paymentMethodText: 'We zullen zorg dragen voor je kaartinformatie en het eenvoudig maken om je aan te melden voor automatische betaling.',
        connectCard: 'Verbind betaalmethode',
        automaticPaymentMethod: 'Automatische betaalmethode',
        deleteCardToChange: 'Je kunt de geselecteerde kaart wijzigen/verwijderen door op de knop kaart verwijderen te klikken.',
        deleteCard: 'Verwijder kaart',
        paymentPlanEntries: 'Invoeren betalingsplan',
        amount: 'Bedrag',
        date: 'Datum',
        status: 'Status',
        statusCode: {
            [payment_plans_1.PaymentPlanEntryStatus.SETTLED]: 'Betaald',
            [payment_plans_1.PaymentPlanEntryStatus.CANCELED]: 'In gebreke gebleven',
            [payment_plans_1.PaymentPlanEntryStatus.PENDING]: 'Toekomstig',
            [payment_plans_1.PaymentPlanEntryStatus.REMINDED]: 'Herinnerd',
            [payment_plans_1.PaymentPlanEntryStatus.AWAITING]: 'In afwachting',
            [payment_plans_1.PaymentPlanEntryStatus.OVERDUE]: 'Achterstallig',
            [payment_plans_1.PaymentPlanEntryStatus.ERRORSETTLED]: 'Mislukte kaarttrekking',
        },
    },
    emailSignature: {
        privacyPolicyText: 'Gegevensverwerking. We kunnen persoonlijke gegevens over u verwerken. U kunt ons privacybeleid hier lezen:',
        regards: 'Met vriendelijke groet',
    },
    pluralEconomyVoucherTypeLabels: {
        [vouchers_1.VoucherTypeIds.PRINCIPAL]: 'Hoofdsommen',
        [vouchers_1.VoucherTypeIds.INVOICE]: 'Facturen',
        [vouchers_1.VoucherTypeIds.ONACCOUNTINVOICE]: 'Facturen op rekening',
        [vouchers_1.VoucherTypeIds.DOM]: 'Vonnis',
        [vouchers_1.VoucherTypeIds.FINALINVOICE]: 'Eindafrekeningen',
        [vouchers_1.VoucherTypeIds.CONTROLFEE]: 'Controlekosten',
        [vouchers_1.VoucherTypeIds.ADMINISTRATIONCOST]: 'Administratiekosten',
        [vouchers_1.VoucherTypeIds.CREDITNOTE]: "Creditnota's",
        [vouchers_1.VoucherTypeIds.YEARLYINTEREST]: 'Jaarlijkse rentes',
        [vouchers_1.VoucherTypeIds.PROCESSINTEREST]: 'Rentes',
        [vouchers_1.VoucherTypeIds.GLPROCESSINTEREST]: 'Rentes (GL)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Samengestelde rente (dagelijkse rentebijschrijving)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Samengestelde rente (maandelijkse rentebijschrijving)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Samengestelde rente (kwartaalrentebijschrijving)',
        [vouchers_1.VoucherTypeIds.REMINDERFEE]: 'Herinneringskosten',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOST]: 'Incassokosten',
        [vouchers_1.VoucherTypeIds.COLLECTIONFEE]: 'Incasso-fee',
        [vouchers_1.VoucherTypeIds.BAILIFFSFEE]: 'Deurwaarderskosten',
        [vouchers_1.VoucherTypeIds.WRITFEE]: 'Schrijfkosten',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Gerechtskosten zonder civiele rechtbank',
        [vouchers_1.VoucherTypeIds.COURTCLAIMSALARY]: 'Salarissen gerechtsclaims',
        [vouchers_1.VoucherTypeIds.BAILIFSSALARY]: 'Salarissen deurwaarders',
        [vouchers_1.VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Kosten gerechtsdeurwaardersrequisitie',
        [vouchers_1.VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Kosten politiepresentatie',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Gerechtskosten met deurwaardersrechtbank',
        [vouchers_1.VoucherTypeIds.WRITSALARY]: 'Schrijfsalarissen',
        [vouchers_1.VoucherTypeIds.COMPENSATIONCOST]: 'Compensatiekosten',
        [vouchers_1.VoucherTypeIds.Folkeregisteropslag]: 'Bevolkingsregister opzoeken',
        [vouchers_1.VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Zaken intellectueel eigendom',
        [vouchers_1.VoucherTypeIds.CIVILCOURTCOST]: 'Kosten civiele rechtbank',
        [vouchers_1.VoucherTypeIds.DEPOSIT]: 'Stortingen',
        [vouchers_1.VoucherTypeIds.WITHDRAWAL]: 'Opnames',
        [vouchers_1.VoucherTypeIds.OVERPAYMENT]: 'Te veel betaald',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSION]: 'Incassoprovisies',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Incassoprovisies (toezicht)',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Incassoprovisies (crediteurgarantie)',
        [vouchers_1.VoucherTypeIds.JURIDISKBISTAND]: 'Juridische bijstand',
        [vouchers_1.VoucherTypeIds.ENDCASEFEE]: 'Einde van de zaak kosten',
        [vouchers_1.VoucherTypeIds.STARTCASEFEE]: 'Begin van de zaak kosten',
        [vouchers_1.VoucherTypeIds.BPKFEE]: 'BPK-kosten',
        [vouchers_1.VoucherTypeIds.FOGEDFEE]: 'Kosten gerechtsdeurwaardersrequisitie',
        [vouchers_1.VoucherTypeIds.RKIREGISTRATIONFEE]: 'RKI-registratiekosten',
        [vouchers_1.VoucherTypeIds.BPKDISBURSEMENT]: 'Uitgaven voor schrijven',
        [vouchers_1.VoucherTypeIds.POLICEDISBURSEMENT]: 'Uitgaven voor politiepresentatie',
        [vouchers_1.VoucherTypeIds.FOGEDDISBURSEMENT]: 'Uitgaven voor gerechtsdeurwaardersrequisitie',
        [vouchers_1.VoucherTypeIds.VAT]: 'BTW',
        [vouchers_1.VoucherTypeIds.GAELDSBREV]: 'Lening',
        [vouchers_1.VoucherTypeIds.SETTLEMENT]: 'Schikking',
        [vouchers_1.VoucherTypeIds.FIXEDINTEREST]: 'Vaste rente',
        [vouchers_1.VoucherTypeIds.UDTRAEKSGEBYR]: 'Opnamekosten',
        [vouchers_1.VoucherTypeIds.DEPOSITPAYOUT]: 'Uitbetalingen van storting',
        [vouchers_1.VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Inschrijvingen in het bevolkingsregister',
        [vouchers_1.VoucherTypeIds.ANMELDELSEAFKRAV]: 'Melding van vordering',
        [vouchers_1.VoucherTypeIds.MeetingFee]: 'Vergoeding voor vergaderingen',
        [vouchers_1.VoucherTypeIds.STAEVNINGSGEBYR]: 'Schrijfkosten',
        [vouchers_1.VoucherTypeIds.BERAMMELSESAFGIFT]: 'Afspraakkosten',
        [vouchers_1.VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Annulering van beslaglegging',
        [vouchers_1.VoucherTypeIds.LOCKSMITHFEE]: 'Slotenmakerkosten',
        [vouchers_1.VoucherTypeIds.DRIVINGFEE]: 'Rijdkosten',
        [vouchers_1.VoucherTypeIds.OTHERFEE]: 'Andere kosten',
        [vouchers_1.VoucherTypeIds.REFUND]: 'Terugbetaling',
    },
    economyVoucherTypeLabels: {
        [vouchers_1.VoucherTypeIds.PRINCIPAL]: 'Hoofdsom',
        [vouchers_1.VoucherTypeIds.INVOICE]: 'Factuur',
        [vouchers_1.VoucherTypeIds.ONACCOUNTINVOICE]: 'Factuur op rekening',
        [vouchers_1.VoucherTypeIds.DOM]: 'Vonnis',
        [vouchers_1.VoucherTypeIds.FINALINVOICE]: 'Laatste afrekening',
        [vouchers_1.VoucherTypeIds.CONTROLFEE]: 'Controlekost',
        [vouchers_1.VoucherTypeIds.ADMINISTRATIONCOST]: 'Administratiekost',
        [vouchers_1.VoucherTypeIds.CREDITNOTE]: 'Kredietnota',
        [vouchers_1.VoucherTypeIds.YEARLYINTEREST]: 'Jaarlijkse rente',
        [vouchers_1.VoucherTypeIds.PROCESSINTEREST]: 'Rente',
        [vouchers_1.VoucherTypeIds.GLPROCESSINTEREST]: 'Rente (GL)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Samengestelde rente (dagelijkse rentebijschrijving)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Samengestelde rente (maandelijkse rentebijschrijving)',
        [vouchers_1.VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Samengestelde rente (kwartaalrentebijschrijving)',
        [vouchers_1.VoucherTypeIds.REMINDERFEE]: 'Herinneringskost',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOST]: 'Inkassokost',
        [vouchers_1.VoucherTypeIds.COLLECTIONFEE]: 'Inkasso-fee',
        [vouchers_1.VoucherTypeIds.COMPENSATIONCOST]: 'Compensatiekost',
        [vouchers_1.VoucherTypeIds.Folkeregisteropslag]: 'Bevolkingsregister opzoeken',
        [vouchers_1.VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Intellectuele eigendomszaken',
        [vouchers_1.VoucherTypeIds.DEPOSIT]: 'Storting',
        [vouchers_1.VoucherTypeIds.WITHDRAWAL]: 'Opname',
        [vouchers_1.VoucherTypeIds.OVERPAYMENT]: 'Overbetaling',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inkassocommissie',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inkassocommissie (toezicht)',
        [vouchers_1.VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inkassocommissie (crediteur storting)',
        [vouchers_1.VoucherTypeIds.JURIDISKBISTAND]: 'Juridische bijstand',
        [vouchers_1.VoucherTypeIds.ENDCASEFEE]: 'Einde van de zaak kost',
        [vouchers_1.VoucherTypeIds.STARTCASEFEE]: 'Begin van de zaak kost',
        [vouchers_1.VoucherTypeIds.BPKFEE]: 'BPK-kost',
        [vouchers_1.VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitions-kost',
        [vouchers_1.VoucherTypeIds.RKIREGISTRATIONFEE]: 'RKI-registratiekost',
        [vouchers_1.VoucherTypeIds.BPKDISBURSEMENT]: 'Schrijfuitbetaling',
        [vouchers_1.VoucherTypeIds.POLICEDISBURSEMENT]: 'Uitbetaling politiepresentatie',
        [vouchers_1.VoucherTypeIds.FOGEDDISBURSEMENT]: 'Uitbetaling van gerechtsdeurwaardersrequisitie',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Gerechtskosten zonder civiele rechtbank',
        [vouchers_1.VoucherTypeIds.COURTCLAIMSALARY]: 'Salaris voor gerechtsclaims',
        [vouchers_1.VoucherTypeIds.VAT]: 'BTW',
        [vouchers_1.VoucherTypeIds.BAILIFFSFEE]: 'Kosten deurwaarder',
        [vouchers_1.VoucherTypeIds.BAILIFSSALARY]: 'Salaris deurwaarder',
        [vouchers_1.VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Kosten politiepresentatie',
        [vouchers_1.VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Gerechtskosten met deurwaardersrechtbank',
        [vouchers_1.VoucherTypeIds.CIVILCOURTCOST]: 'Omkostingen burgerlijke rechtbank',
        [vouchers_1.VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Kosten gerechtsdeurwaardersrequisitie',
        [vouchers_1.VoucherTypeIds.WRITFEE]: 'Schrijfkosten',
        [vouchers_1.VoucherTypeIds.WRITSALARY]: 'Salaris voor schrijven',
        [vouchers_1.VoucherTypeIds.GAELDSBREV]: 'Lening',
        [vouchers_1.VoucherTypeIds.SETTLEMENT]: 'Schikking',
        [vouchers_1.VoucherTypeIds.FIXEDINTEREST]: 'Vaste rente',
        [vouchers_1.VoucherTypeIds.UDTRAEKSGEBYR]: 'Uittrekkingskosten',
        [vouchers_1.VoucherTypeIds.DEPOSITPAYOUT]: 'Uitbetaling van storting',
        [vouchers_1.VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Inschrijvingen in het bevolkingsregister',
        [vouchers_1.VoucherTypeIds.ANMELDELSEAFKRAV]: 'Melding van vordering',
        [vouchers_1.VoucherTypeIds.MeetingFee]: 'Vergoeding voor vergaderingen',
        [vouchers_1.VoucherTypeIds.STAEVNINGSGEBYR]: 'Schrijfkosten',
        [vouchers_1.VoucherTypeIds.BERAMMELSESAFGIFT]: 'Afspraakkosten',
        [vouchers_1.VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Annulering van beslaglegging',
        [vouchers_1.VoucherTypeIds.LOCKSMITHFEE]: 'Slotenmakerkosten',
        [vouchers_1.VoucherTypeIds.DRIVINGFEE]: 'Rijdkosten',
        [vouchers_1.VoucherTypeIds.OTHERFEE]: 'Andere kosten',
        [vouchers_1.VoucherTypeIds.REFUND]: 'Terugbetaling',
    },
};
exports.default = map;
//# sourceMappingURL=nl.js.map